/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Reconcile_NowInputs */

const cs_portals_reconcile_now = /** @type {(inputs: Portals_Reconcile_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconcile teď`)
};

const en_portals_reconcile_now = /** @type {(inputs: Portals_Reconcile_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconcile now`)
};

/**
* | output |
* | --- |
* | "Reconcile now" |
*
* @param {Portals_Reconcile_NowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_reconcile_now = /** @type {((inputs?: Portals_Reconcile_NowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Reconcile_NowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_reconcile_now(inputs)
	return cs_portals_reconcile_now(inputs)
});